const SEVERITY = {
  critical: { bg: '#FEE2E2', text: '#991B1B', border: '#EF4444' },
  warning: { bg: '#FEF3C7', text: '#92400E', border: '#F59E0B' },
  info: { bg: '#F3F4F6', text: '#374151', border: '#9CA3AF' },
};

export default function Badge({ severity, text, className = '' }) {
  const s = SEVERITY[severity] || SEVERITY.info;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold border ${className}`}
      style={{ background: s.bg, color: s.text, borderColor: `${s.border}40` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.border }} />
      {text}
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    EXPECTED: { bg: '#FEF3C7', text: '#92400E', dot: '#F59E0B', label: 'Credit Expected' },
    ON_STATEMENT: { bg: '#DBEAFE', text: '#1E40AF', dot: '#3B82F6', label: 'On Statement' },
    RECONCILED: { bg: '#DCFCE7', text: '#166534', dot: '#22C55E', label: 'Reconciled' },
    DISPUTED: { bg: '#FEE2E2', text: '#991B1B', dot: '#EF4444', label: 'Disputed' },
  };
  const c = map[status] || map.EXPECTED;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold"
      style={{ background: c.bg, color: c.text }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c.dot }} />
      {c.label}
    </span>
  );
}
